<footer class="footer" #footer [class.hidden]="scroll.footerHidden()">
  <div class="footer-content">

    <!-- Impressum -->
    <button
      aria-controls="imprint-overlay"
      class="footer-link"
      data-translate="FOOTER.IMPRINT"
        [class.active]="isImprintActive()"
  [disabled]="overlay().overlays.imprint.busy"
  (click)="toggleImprint.emit()"
    >
    </button>

    <p class="copyright">
      Copyright © 2025 Marc Wieland &lt;/Software &amp; Consulting&gt;.
    </p>

    <!-- Privacy -->
    <button
      aria-controls="privacy-policy-overlay"
      class="footer-link"
      data-translate="FOOTER.PRIVACY"
  [class.active]="isPrivacyActive()"
  [disabled]="overlay().overlays.privacy.busy"
  (click)="togglePrivacy.emit()"
    >
    </button>

  </div>
</footer>
